import { ClientDiscount } from "utils/interfaces"
export function sortDiscounts(discounts: ClientDiscount[]) {
    return discounts.slice().sort((a, b) => {
        if (a.last_used_at === b.last_used_at) {
            return b.discount_id - a.discount_id
        }
        return ((a.can_be_applied && a.last_used_at) || "") >
            ((b.can_be_applied && b.last_used_at) || "")
            ? -1
            : 1
    })
}
